import React from "react";
import "../styles/Servicios.css";
import backgroundImage from "../assets/images/iStock_000009558758Small.jpg";

const Servicios = ({ traducciones }) => {
  return (
    <div
      className="servicios-container d-flex align-items-center text-white"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="container">
        <div className="row">
          {/* Columna para el título */}
          <div className="col-lg-6 col-md-12 d-flex align-items-center justify-content-center text-center text-lg-start">
            <h2 className="titulo-servicios">
              {traducciones.servicios
                ? traducciones.servicios.titulo
                : "SERVICIOS"}
            </h2>
          </div>

          {/* Columna para los detalles */}
          <div className="col-lg-6 col-md-12 detalles-servicios-contenedor mt-4 mt-lg-0">
            <div
              className="detalles-servicios"
              dangerouslySetInnerHTML={{
                __html: traducciones.servicios
                  ? traducciones.servicios.texto
                  : "",
              }}
            ></div>
            <button
              className="btn servicios-button mt-3"
              onClick={() => {
                const section = document.getElementById("contacto");
                if (section) {
                  section.scrollIntoView({ behavior: "smooth" });
                }
              }}
            >
              {traducciones.servicios
                ? traducciones.servicios.boton
                : "Contacto"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Servicios;